import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import StatisticsShare from '../../components/Statistics/StatisticsShare';
import Icon from '../../components/Icon/Icon';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const ActionModal = ({
  isMasterAccPage,
  isOpen,
  handleClose,
  isMember,
  isSharing,
  setSharingState,
  showAlert,
  requestParams,
  theme,
  handleRefresh,
  handleHasEditingModalToggle,
  handleHasExportModalToggle,
  handleOpenAddMemberModal,
}) => {
  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      toggle={handleClose}
      centered
      autoFocus
      className="modal-lg action-modal"
    >
      <ModalHeader toggle={handleClose}>
        <FormattedMessage id="statistics.action-modal.title" defaultMessage="Actions" />
      </ModalHeader>

      <ModalBody>
        <div className="action-modal-wrapper">
          {!isMember && (
            <StatisticsShare
              isLoading={isSharing}
              setSharingState={setSharingState}
              showAlert={showAlert}
              requestParams={requestParams}
              theme={theme}
              onClick={handleClose}
              children={<FormattedMessage id="statistics.share.button" defaultMessage="Share" />}
            />
          )}
          <button
            onClick={() => {
              handleHasExportModalToggle();
              handleClose();
            }}
          >
            <Icon type="download" /> Скачать
          </button>
          {!isMasterAccPage && (
            <button
              className="action-modal-refresh"
              onClick={() => {
                handleRefresh();
                handleClose();
              }}
            >
              <Icon type="refresh" /> Обновить
            </button>
          )}
          {isMasterAccPage && (
            <button
              onClick={() => {
                handleOpenAddMemberModal();
                handleClose();
              }}
              className="action-modal-add-member"
            >
              <span /> Добавить участника
            </button>
          )}
        </div>
        <div className="action-modal-wrapper">
          <button
            className="action-modal-edit-table"
            onClick={() => {
              handleHasEditingModalToggle();
              handleClose();
            }}
          >
            <SVG
              src={`${STATIC_PATH}/img/action-icons/settings2-icon.svg`}
              height="20"
              width="20"
              cacheRequests
            />
            Редактировать таблицу
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ActionModal;
